import { debug } from '../../../utils'
import { Observable as O } from 'rxjs/Observable'
import 'rxjs/add/operator/pluck'
import { dragMap, setMapControlled, setMapLocation } from './actions'
import * as actions from './actions'
import 'rxjs/add/observable/empty'
import 'rxjs/add/observable/from'
import 'rxjs/add/operator/switchMap'

const log = debug('lego:models/Map/epics')

const dragMapEpic = (action$, store) => action$
 .ofType(dragMap.names.START)
 .switchMap(({ payload }) => {
	if (store.getState().mapState.map_controlled) { return O.empty() }
	return O.from([
		 //setMapLocation(store.getState().mapState.map_location),
			setMapControlled({map_controlled: true}),
		]);
	});

import get from 'lodash/get'
const noop = () => null
const resultSelectedEpic = (action$, store) => action$
 .ofType(actions.SET_RESULT_SELECTED)
 .switchMap(({ payload }) => {
   const state = store.getState()
	 const map = get(state, 'mapState.mapComponent', noop)()
	 const { selected } = payload
	 const placeCoords = get(state.places[selected], 'data.location.position', null)

	 return O.from([ setMapLocation(placeCoords) ])
	})

export { dragMapEpic, resultSelectedEpic }



// WEBPACK FOOTER //
// ./src/app/models/Map/epics.ts